module.exports = __webpack_public_path__ + "img/billboard_brisach.d3f7982e.jpg";